var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warehouse-label-a4"},_vm._l((_vm.printData),function(item,index){return _c('div',{key:index,staticClass:"warehouse-label-a4-page"},[_c('div',{staticClass:"warehouse-label-a4-grid-number"},[_vm._v(_vm._s(_vm.getGridNumber(item)))]),_c('img',{staticClass:"warehouse-label-a4-qr-code",attrs:{"src":item.url,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }